module.exports = __webpack_public_path__ + "2a012197b3f6ba8d1498cd6a8b3412ac.png";